import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const productsWeekDefaultBlocks: BlockNode[] = [
  {
    id: 'products-week-heading',
    type: 'text',
    content: { type: 'text', value: 'Products of the Week', fontSize: 28, fontWeight: 700, textAlign: 'left' },
    layout: { order: 0, widthPct: 100 },
  },
];

export const productsWeekWidget = defineWidget({
  type: 'products-week',
  schema: {
    label: 'Products of the Week',
    description: 'Weekly highlighted products carousel',
    props: {
      limit: {
        type: 'number',
        label: 'Number of products',
        min: 1,
        max: 50,
        default: 8,
        structural: true,
      },
    },
    slots: {
      heading: { type: 'text', label: 'Section Heading' },
    },
    dataDeps: ['newestProducts'],
  },
  nameTh: 'สินค้าประจำสัปดาห์',
  descriptionTh: 'สินค้าไฮไลต์ประจำสัปดาห์',
  category: 'products',
  thumbnail: '/widget-thumbnails/products-week.svg',
  defaults: {
    type: 'products-week',
    props: { limit: 8 },
    slots: {
      heading: { value: 'Products of the Week' },
    },
  },
  defaultBlocks: productsWeekDefaultBlocks,
});
